
import { PropType, defineComponent } from 'vue'

export default defineComponent({
    props: {
        startColor: {
            type: String as PropType<string>,
            default: () => '#F3D68F'
        },
        endColor: {
            type: String as PropType<string>,
            default: () => '#A18240'
        }
    }
})
